// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__nCYXd","buttons":"RemoveExpirationActionButtons_buttons__1iMQx"};